import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { t } from '@sm/intl';
import { Box } from '@wds/box';

import FrequentlyAskedQuestion from './components/FAQ';
import FAQAnswer from './components/FAQAnswer';
import usePricingFooterStyles from './useStyles';

import COPY from './copy';
import { MoreAboutProps } from './types';
import { ROOT_PRICING_ROUTE } from '~shared/constants/pricing';

export default function MoreAbout({
  displayTeamsDiscountFAQ,
  teamsDiscountPercent,
  pageUtSource,
  utSource2,
  utSource3,
  displayEduFaq, // optional since most experiments currently exclude edu_faq
}: MoreAboutProps): ReactElement {
  const { PricingList } = usePricingFooterStyles();
  return (
    <Box className={PricingList} data-testid="MoreAbout__Section">
      {displayEduFaq && (
        <FrequentlyAskedQuestion
          data-testid="MoreAbout__EduPricing"
          heading={t(COPY.SPECIAL_PRICING_FOR_EDUCATORS_FAQ)}
        >
          <FAQAnswer>
            {t(COPY.SPECIAL_PRICING_FOR_EDUCATORS_ANSWER)}{' '}
            <Link to={`${ROOT_PRICING_ROUTE}/educational/?ut_source=${pageUtSource}`}>{t(COPY.SEE_PRICING)}</Link>
          </FAQAnswer>
        </FrequentlyAskedQuestion>
      )}

      <FrequentlyAskedQuestion heading={t(COPY.CORPORATE_PLANS_FAQ)}>
        <FAQAnswer>
          {t(COPY.CORPORATE_PLANS_ANSWER)}{' '}
          <a
            href={`/mp/contact-sales/?ut_source=pricing_page&ut_source2=${utSource2}&ut_source3=${utSource3}`}
            target="_blank"
            rel="noreferrer"
          >
            {t(COPY.CONTACT_SALES)}
          </a>
        </FAQAnswer>
      </FrequentlyAskedQuestion>

      {displayTeamsDiscountFAQ && (
        <FrequentlyAskedQuestion heading={t(COPY.DISCOUNTS_FOR_TEAMS_FAQ)}>
          <FAQAnswer>
            {t(COPY.DISCOUNTS_FOR_TEAMS_ANSWER, { teamsMinimumDiscount: teamsDiscountPercent })}{' '}
            <Link to={`${ROOT_PRICING_ROUTE}/teams/details/?ut_source=${pageUtSource}`}>{t(COPY.SEE_PRICING)}</Link>
          </FAQAnswer>
        </FrequentlyAskedQuestion>
      )}
    </Box>
  );
}
